import {
	LoadingSkeleton,
	LoadingSkeletonItem,
} from 'components/LoadingSkeleton';

interface Props {
	className?: string;
}

export default function LoadingReviewSkeleton({ className }: Props) {
	return (
		<LoadingSkeleton className={className}>
			{/* Flag and name */}
			<div className="mb-4 flex items-center gap-2">
				<LoadingSkeletonItem
					height="1.5rem"
					width="1.5rem"
					className="rounded-full"
				/>
				<LoadingSkeletonItem height="1rem" width="5rem" />
			</div>
			{/* Date */}
			<LoadingSkeletonItem height="1rem" width="13rem" className="mt-1" />
			{/* Stars */}
			<LoadingSkeletonItem height="1.5rem" width="7.5rem" className="mt-4" />
			{/* Main text */}
			<LoadingSkeletonItem height="5rem" width="100%" className="my-4" />
			{/* Like/report buttons */}
			<LoadingSkeletonItem height="2rem" width="12rem" className="mt-6" />
		</LoadingSkeleton>
	);
}
LoadingReviewSkeleton.displayName = 'LoadingReviewSkeleton';
